/**
 * Focus Sidebar
 * Vertical sidebar for launching focus panels
 */
export class FocusSidebar {
  constructor(container, workspaceManager) {
    this.container = container;
    this.workspaceManager = workspaceManager;

    this.panels = [
      { id: 'brain-dump', label: 'Brain Dump', icon: '🧠', shortcut: '⌘1' },
      { id: 'capacity', label: 'Capacity', icon: '⚡', shortcut: '⌘2' },
      { id: 'projects', label: 'Projects', icon: '📋', shortcut: '⌘3' },
      { id: 'values', label: 'Values & Anchors', icon: '🎯', shortcut: '⌘4' },
      { id: 'calendar', label: 'Schedule', icon: '📅', shortcut: '⌘5' }
    ];

    this.render();
    this.attachListeners();
  }

  render() {
    this.container.innerHTML = `
      <nav class="focus-sidebar" role="navigation" aria-label="Focus panels">
        <div class="focus-sidebar__items">
          ${this.panels.map(panel => this.renderPanelButton(panel)).join('')}
        </div>
        <div class="focus-sidebar__footer">
          <button class="focus-sidebar__btn focus-sidebar__btn--secondary"
                  data-action="clear-all"
                  aria-label="Clear all panels"
                  title="Clear all">
            <span class="icon">🗑️</span>
          </button>
        </div>
      </nav>
    `;
  }

  renderPanelButton(panel) {
    const isActive = this.workspaceManager.isPanelActive(panel.id);

    return `
      <button
        class="focus-sidebar__btn ${isActive ? 'active' : ''}"
        data-panel-id="${panel.id}"
        data-action="toggle-panel"
        aria-label="${panel.label}"
        aria-pressed="${isActive}"
        title="${panel.label} (${panel.shortcut})"
      >
        <span class="icon">${panel.icon}</span>
        <span class="label">${panel.label}</span>
        ${isActive ? '<span class="active-indicator"></span>' : ''}
      </button>
    `;
  }

  attachListeners() {
    // Panel toggle buttons
    this.container.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action="toggle-panel"]');
      if (btn) {
        const panelId = btn.dataset.panelId;
        this.workspaceManager.togglePanel(panelId);
        this.updateUI();
      }

      // Clear all button
      const clearBtn = e.target.closest('[data-action="clear-all"]');
      if (clearBtn) {
        this.workspaceManager.activePanels.forEach(panelId => {
          this.workspaceManager.removePanel(panelId);
        });
        this.updateUI();
      }
    });

    // Listen for workspace changes
    document.addEventListener('workspace-changed', () => {
      this.updateUI();
    });
  }

  updateUI() {
    // Re-render to update active states
    this.render();
    this.attachListeners();
  }
}
